module.exports = __webpack_public_path__ + "static/media/tik.58d5e9f7.png";